// extracted by mini-css-extract-plugin
export default {"tableStatusContainer":"components_tableStatusContainer__DfkSX","tableStatus":"components_tableStatus__XwYay"};